import { getApiClient } from '../../client';
import { handleApiError } from '../../utils/handleApiError';
import type { EnsureVisitResponse, ServiceResponse } from '@dopomogai/types';

export interface SaveRoadmapPayload {
  email: string;
  result: any;
  visitor_id?: string;
  smartlook_url?: string; // NEW
}

interface EnsureVisitPayload {
  visitor_id: string;
  source: string;
  path: string;
}

// Add window type definition for smartlook
declare global {
    interface Window {
        smartlook?: any;
    }
}

class LeadsService {
  async ensureVisit(payload: EnsureVisitPayload): Promise<ServiceResponse<EnsureVisitResponse>> {
    try {
      const client = getApiClient();
      const response = await client.post<EnsureVisitResponse>('/leads/ensure-visit', payload);
      return response.data;
    } catch (error) {
      return handleApiError(error, 'ensure visit');
    }
  }

  async saveRoadmap(payload: SaveRoadmapPayload): Promise<ServiceResponse<{ status: string; result_id: string }>> {
    try {
      // 1. Try to get Smartlook URL if not provided
      if (!payload.smartlook_url && typeof window !== 'undefined' && window.smartlook) {
          try {
              // Smartlook API to get visitor URL
              // This varies by SDK version, usually:
              payload.smartlook_url = window.smartlook.visitor.getURL();
          } catch (e) {
              console.warn("Could not retrieve Smartlook URL", e);
          }
      }

      const client = getApiClient();
      const response = await client.post<{ status: string; result_id: string }>('/leads/save-roadmap', payload);
      return response.data;
    } catch (error) {
      return handleApiError(error, 'save roadmap');
    }
  }
}

export const leadsService = new LeadsService();